module.exports = __webpack_public_path__ + "img/svg/trophy-won.c450cb2f67061020a847deb64cec6f72.svg";